import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import PageSEO from "@/components/seo/PageSEO";

const SignUp = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    const { error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        emailRedirectTo: `${window.location.origin}/app`,
      },
    });

    if (error) {
      toast({
        title: "Erro ao cadastrar",
        description: error.message,
        variant: "destructive",
      });
    } else {
      toast({
        title: "Cadastro realizado com sucesso!",
        description: "Verifique seu email para confirmar o cadastro.",
      });
      navigate("/login");
    }

    setLoading(false);
  };

  const breadcrumbs = [
    {
      position: 1,
      name: "Início",
      item: "https://youcalm.org"
    },
    {
      position: 2,
      name: "Cadastro",
      item: "https://youcalm.org/cadastro"
    }
  ];

  return (
    <>
      <PageSEO 
        title="Cadastro - YouCalm | Crie sua conta gratuita de bem-estar mental"
        description="Crie sua conta gratuita na YouCalm e comece sua jornada de autoconhecimento com testes de personalidade, meditação guiada e ferramentas de bem-estar mental."
        canonicalUrl="https://youcalm.org/cadastro"
        keywords="cadastro YouCalm, conta gratuita, bem-estar mental, testes personalidade, meditação"
        pageName="Cadastro"
        breadcrumbs={breadcrumbs}
      />
      
      <div className="flex justify-center items-center h-screen bg-gray-100">
        <Card className="w-full max-w-md">
          <CardHeader className="space-y-1">
            <CardTitle className="text-2xl text-center">Criar uma conta</CardTitle>
            <CardDescription className="text-center">
              Insira seu email e senha para criar sua conta
            </CardDescription>
          </CardHeader>
          <CardContent className="grid gap-4">
            <div className="grid gap-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                placeholder="seuemail@exemplo.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="password">Senha</Label>
              <Input
                id="password"
                type="password"
                placeholder="Senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </CardContent>
          <CardFooter>
            <Button className="w-full" onClick={handleSubmit} disabled={loading}>
              {loading ? "Carregando..." : "Criar conta"}
            </Button>
          </CardFooter>
          <div className="text-center mt-4">
            <Link to="/login" className="text-sm text-gray-500 hover:text-gray-700">
              Já tem uma conta? Faça login
            </Link>
          </div>
        </Card>
      </div>
    </>
  );
};

export default SignUp;
